import * as React from 'react';

const Klarna32 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 32 32", width: 32, height: 32, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#FFA8CD",
    d: "M0 9a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#000",
    fillOpacity: 0.08,
    d: "M4 6h24a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V9a3 3 0 0 1 3-3m0-1a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4V9a4 4 0 0 0-4-4z",
    style: {
      mixBlendMode: "multiply"
    }
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#000",
    d: "M24.948 17.7a.92.92 0 0 1-.908-.935c0-.512.397-.935.908-.935a.92.92 0 0 1 .908.935.92.92 0 0 1-.908.935m-.255.987c.435 0 .99-.166 1.298-.814l.03.015c-.135.354-.135.566-.135.618v.083h1.096v-3.648h-1.096v.083c0 .053 0 .264.136.618l-.03.015c-.308-.648-.864-.814-1.3-.814-1.043 0-1.779.83-1.779 1.922s.736 1.922 1.78 1.922m-3.686-3.844c-.496 0-.886.173-1.201.814l-.03-.015c.135-.354.135-.565.135-.618v-.083h-1.096v3.648h1.126v-1.922c0-.505.293-.822.765-.822q.708 0 .706.815v1.93h1.126v-2.322c0-.83-.646-1.425-1.531-1.425m-3.821.814-.03-.015c.135-.354.135-.565.135-.618v-.083h-1.096v3.648h1.126l.007-1.756c0-.513.27-.822.713-.822.12 0 .218.015.33.046V14.94c-.495-.106-.938.083-1.185.716ZM13.605 17.7a.92.92 0 0 1-.909-.935.92.92 0 0 1 .909-.935.92.92 0 0 1 .908.935.92.92 0 0 1-.908.935m-.255.987c.435 0 .99-.166 1.298-.814l.03.015c-.135.354-.135.566-.135.618v.083h1.096v-3.648h-1.096v.083c0 .053 0 .264.135.618l-.03.015c-.308-.648-.863-.814-1.298-.814-1.044 0-1.78.83-1.78 1.922s.736 1.922 1.78 1.922M10 18.59h1.126v-5.276H10zm-.825-5.276h-1.15c0 .942-.577 1.786-1.455 2.39l-.346.24v-2.63H5.032v5.276h1.193v-2.615L8.2 18.589h1.456l-1.9-2.502c.864-.626 1.427-1.598 1.42-2.774Z"
  }
));
Klarna32.Size = 32;
Klarna32.Title = "Klarna";

export { Klarna32 as default };
